<template>
    <div class="funItem">
        <div v-if="title" class="section-title">{{ title }}</div>
        <div class="download-grid">
            <div :key="item.id" v-for="item in list" class="card">
                <div class="file-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                        <polyline points="14 2 14 8 20 8"/>
                        <line x1="16" y1="13" x2="8" y2="13"/>
                        <line x1="16" y1="17" x2="8" y2="17"/>
                    </svg>
                </div>
                <div class="content">
                    <div class="file-title">{{ item.title }}</div>
                    <div class="file-desc">{{ item.desc }}</div>
                    <div class="file-meta">
                        <template v-if="Number(item.page_size) > 0">{{ $t('页码：') }}{{ item.page_size }}</template>
                        <template v-if="Number(item.page_size) > 0 && Number(item.file_size) > 0"> · </template>
                        <template v-if="Number(item.file_size) > 0">{{ item.file_size }}MB</template>
                    </div>
                </div>
                <div @click="downloadFile(item.url,item )" class="download-btn">{{ $t('download.downloadBtn') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { check_download } from "@/api/download.js"
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        list: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        async downloadFile(url,item) {
            if (!url) return
            // 登录前置校验：无 token 直接引导登录
            const token = localStorage.getItem('user_token')
            if (!token) {
                this.$message.warning(this.$t('download.loginRequired'))
                this.goLogin()
                return
            }
            // 下载权限校验：登录 + 审核通过 + 状态开启
            // download 端点本身公开(供邮件/外链永久链接)，权限由本接口校验
            try {
                await check_download({ id: item.id, uuid: item.uuid })
            } catch (err) {
                // 权限不足时全局拦截器已弹提示；token 失效跳登录
                if (err && err.code === 401) {
                    this.goLogin()
                }
                return
            }
            // 校验通过，触发下载（公开链接）
            try {
                // 先用 fetch 探测后端响应：302 跳转表示文件存在，JSON 表示业务错误
                const lang = this.$i18n && this.$i18n.locale || 'zh'
                // 浏览器直接导航(<a>/window.open)无法携带自定义请求头，
                // 故把语言作为查询参数附加到 URL，后端 getLang() 会回退读取，
                // 确保实际下载请求与探测请求命中同一语言库
                const sep = url.indexOf('?') === -1 ? '?' : '&'
                url = url + sep + 'lang=' + encodeURIComponent(lang)
                const response = await fetch(url, {
                    redirect: 'manual',
                    headers: { 'xzd-lang': lang }
                })

                // 302 跳转 → 文件存在，触发浏览器下载
                if (response.type === 'opaqueredirect') {
                    const a = document.createElement('a')
                    a.href = url
                    a.target = '_blank'
                    a.rel = 'noopener'
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                    return
                }

                // 判断响应类型：JSON → 业务错误弹窗；非 JSON（如 PHP 错误）→ 跳转查看
                const contentType = response.headers.get('content-type') || ''
                if (contentType.includes('json')) {
                    const data = await response.json()
                    this.$message.error(data.msg || this.$t('下载失败11'))
                    return
                }

                // 非 JSON 响应（PHP 异常/500 等）→ 跳转到错误页面方便调试
                window.open(url, '_blank')
            } catch (e) {
                this.$message.error(this.$t('下载失败22'+e+url))
            }
        },
        // 跳转登录页，登录后回到当前下载页
        goLogin() {
            const lang = (localStorage.getItem('i18n-lang') || 'zh') === 'zh' ? 'cn' : 'en'
            const redirect = (this.$route && this.$route.fullPath) || ('/' + lang + '/download')
            this.$router.push('/' + lang + '/login?redirect=' + encodeURIComponent(redirect))
        }
    },
}
</script>

<style lang="scss" scoped>
.funItem {
    .section-title {
        font-size: 22px;
        font-weight: bold;
        color: #000000;
        margin-bottom: 24px;
    }

    .download-grid {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .card {
            display: flex;
            align-items: center;
            gap: 24px;
            padding: 28px 30px;
            background: #FFFFFF;
            border: 1px solid #E5E5E5;
            border-radius: 2px;
            transition: all 0.2s;

            &:hover {
                border-color: #000000;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
            }

            .file-icon {
                width: 40px;
                height: 40px;
                flex-shrink: 0;
                color: #000000;
                opacity: 0.85;

                svg {
                    width: 100%;
                    height: 100%;
                }
            }

            .content {
                flex: 1;
                min-width: 0;
                display: flex;
                flex-direction: column;
                gap: 8px;

                .file-title {
                    font-size: 16px;
                    font-weight: bold;
                    color: #000000;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .file-desc {
                    font-size: 14px;
                    color: #666666;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .file-meta {
                    font-size: 13px;
                    color: #999999;
                }
            }

            .download-btn {
                flex-shrink: 0;
                padding: 10px 28px;
                box-sizing: border-box;
                max-width: 100%;
                background: #000000;
                color: #FFFFFF;
                font-size: 14px;
                font-weight: 400;
                cursor: pointer;
                transition: opacity 0.2s;
                border-radius: 0;
                user-select: none;

                &:hover {
                    opacity: 0.8;
                }
            }
        }
    }
}

@media screen and (max-width: 1200px) {
    .funItem {
        .download-grid .card {
            padding: 20px;
            gap: 16px;
        }
    }
}

@media screen and (max-width: 768px) {
    .funItem {
        .download-grid .card {
            flex-wrap: wrap;
            padding: 18px;

            .content {
                width: calc(100% - 56px);
            }

            .download-btn {
                width: 100%;
                text-align: center;
                margin-top: 16px;
            }
        }
    }
}
</style>
